<template>
  <div>
    <el-dialog title="权益信息" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
               :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog"  width="90%" style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>

      <!-- 品牌信息 -->
      <div class="detail-wrap">
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>权益信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
<!--                <th>-->
<!--                  <em class="f-red">*</em>-->
<!--                  产品品牌-->
<!--                </th>-->
<!--                <td>-->
<!--                  <el-select v-model="formData.brandId" placeholder="请选择品牌" style="width: 165px;"-->
<!--                             clearable>-->
<!--                    <el-option v-for="item in brandOptions" :key="item.value" :label="item.label"-->
<!--                               :value="item.value">-->
<!--                    </el-option>-->
<!--                  </el-select>-->
<!--                </td>-->
<!--                <th>-->
<!--                  <em class="f-red">*</em>-->
<!--                  产品名称-->
<!--                </th>-->
<!--                <td>-->
<!--                  <el-input type="text" autocomplete="off" v-model="formData.itemName" clearable style="width: 165px;" readonly=true>-->
<!--                    <i slot="suffix" class="el-input__icon el-icon-search" @click="showItemDialogFunc"></i>-->
<!--                  </el-input>-->
<!--                </td>-->
                <th>
                  <em class="f-red">*</em>
                  权益名称
                </th>
                <td><!-- :disabled="true" -->
<!--                  <el-input type="text" autocomplete="off" v-model="formData.rightsName"  clearable/>-->
                  <el-input type="text" autocomplete="off" v-model="formData.rightsName" style="width: 165px;" clearable readonly=true>
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="showDesignRightsDialog = true"></i>
                  </el-input>
                </td>
                <th>
                  <em class="f-red">*</em>
                  权益分类
                </th>
                <td>
                  <el-select v-model="formData.rightsCategory" style="width: 165px;" clearable>
                    <el-option label="默认" :value="0"/>
                    <el-option label="资产条码权益" :value="1"/>
                    <el-option label="资产型号权益" :value="2"/>
                    <el-option label="用户权益" :value="3"/>
                  </el-select>
                </td>
                <th>
                  <em class="f-red">*</em>
                  权益类型
                </th>
                <td>
                  <el-select v-model="formData.rightsType" style="width: 165px;" clearable>
                    <el-option label="保修卡" :value="1"/>
                    <el-option label="延保卡" :value="2"/>
                    <el-option label="保养卡" :value="3"/>
                    <el-option label="清洗卡" :value="4"/>
                    <el-option label="其他" :value="9"/>
                  </el-select>
                </td>

                <th>
                  <em class="f-red">*</em>
                  权益状态
                </th>
                <td>
                  <el-select v-model="formData.rightsStat" style="width: 165px;" clearable>
                    <el-option label="未激活" :value="0"/>
                    <el-option label="有效" :value="1"/>
                    <el-option label="无效" :value="3"/>
                    <el-option label="做废" :value="9"/>
                  </el-select>
                </td>
              </tr>

              <div style="height: 5px;"></div>
              <tr>
                <th>
                  绑定条码
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.barcode" style="width: 165px;" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  计数方式
                </th>
                <td>
                  <el-select v-model="formData.countTimesType" style="width: 165px;" clearable > <!-- @change="findRightsType" -->
                    <el-option label="按时间" :value="1"/>
                    <el-option label="按次数" :value="2"/>
                    <el-option label="累加保修时间" :value="3"/>
                  </el-select>
                </td>
                <th>
                  <em class="f-red">*</em>
                  权益开始时间
                </th>
                <td>
                  <el-date-picker v-model="formData.beginDate" type="date" style="width: 165px;" :disabled="isRightsTime" placeholder="选择日期" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </td>
                <th>
                  <em class="f-red">*</em>
                  权益结束时间
                </th>
                <td>
                  <el-date-picker v-model="formData.endDate" type="date" placeholder="选择日期" :disabled="isRightsTime" style="width: 165px;" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </td>
              </tr>
              <tr>
                <th>
                  权益卡号
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.rightsNo" style="width: 165px;" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>
                  权益可使用次数
                </th>
                <td>
                  <el-input type="number" autocomplete="off" min="0" v-model="formData.unUesedTimes" :disabled="isRightsCount" clearable style="width: 165px;"/>
                </td>
                <th>
                  权益已使用次数
                </th>
                <td>
                  <el-input type="number" autocomplete="off" min="0" v-model="formData.uesedTimes" :disabled="isRightsCount" clearable style="width: 165px;"/>
                </td>
                <th>
                  权益累加(按月)
                </th>
                <td>
                  <el-input type="number" autocomplete="off" min="0" v-model="formData.rightsMonthes" :disabled="isRightsMonths" clearable style="width: 165px;"/>
                </td>
              </tr>

              <div style="height: 5px;"></div>
              <tr>
<!--                <th>-->
<!--                  <em class="f-red">*</em>-->
<!--                  是否可抵扣费用-->
<!--                </th>-->
<!--                <td>-->
<!--                  <el-select v-model="formData.isReplaceFee" style="width: 165px;" clearable>-->
<!--                    <el-option label="否" :value="0"/>-->
<!--                    <el-option label="是" :value="1"/>-->
<!--                  </el-select>-->
<!--                </td>-->
<!--                <th>-->
<!--                  <em class="f-red">*</em>-->
<!--                  可抵扣费用-->
<!--                </th>-->
<!--                <td>-->
<!--                  <el-select v-model="formData.replaceFeeType" style="width: 165px;" clearable>-->
<!--                    <el-option label="清洗费" :value="1"/>-->
<!--                    <el-option label="上门费" :value="2"/>-->
<!--                    <el-option label="配件费" :value="3"/>-->
<!--                    <el-option label="滤芯费" :value="4"/>-->
<!--                    <el-option label="以旧换新" :value="5"/>-->
<!--                    <el-option label="其他" :value="9"/>-->
<!--                  </el-select>-->
<!--                </td>-->
                <th>
                  费用类型
                </th>
                <td>
                  <el-select v-model="formData.feeType" style="width: 165px;" clearable>
                    <el-option label="费用类" :value="1"/>
                    <el-option label="非费用类" :value="2"/>
                  </el-select>
                </td>
                <th>
                  额度类型
                </th>
                <td>
                  <el-select v-model="formData.isLimit" style="width: 165px;" clearable>
                    <el-option label="不限额" :value="1"/>
                    <el-option label="限额" :value="2"/>
                    <el-option label="常规" :value="3"/>
                  </el-select>
                </td>
                <th>
                  最高限额
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.limitAmount" style="width: 165px;" clearable/>
                </td>
                <th>
                  销售价
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.salePrice" style="width: 165px;" clearable/>
                </td>
              </tr>

              <div style="height: 5px;"></div>
              <tr>
                <th>
                  商品编码
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.productNo" style="width: 165px;" clearable/>
                </td>
                <th>
                  销售订单号
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.saleOrderNo" style="width: 165px;" clearable/>
                </td>
                <th>
                  单位
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.unit" style="width: 165px;" clearable/>
<!--                  <el-select v-model="formData.unit" style="width: 165px;" clearable>-->
<!--                    <el-option label="月" :value="1"/>-->
<!--                    <el-option label="次" :value="2"/>-->
<!--                  </el-select>-->
                </td>
                <th>
                  权益条款
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.rightsRemark" style="width: 165px;" clearable/>
                </td>
              </tr>
              <div style="height: 5px;"></div>
<!--              <tr>-->
<!--                <th>-->
<!--                  成本价-->
<!--                </th>-->
<!--                <td>-->
<!--                  <el-input type="text" autocomplete="off" v-model="formData.costPrice" style="width: 165px;" clearable/>-->
<!--                </td>-->
<!--              </tr>-->
<!--              <div style="height: 5px;"></div>-->
              </tbody>
            </table>
          </div>

        </div>
      </div>
      <span slot="footer" class="dialog-footer">
			  <span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>
			  <el-button type="primary" plain class="button-sty" @click="dialogClose">
				  <i class="el-icon-close el-icon"></i>
				  取 消
			  </el-button>
			  <el-button type="primary" v-if="userRightsEdit" @click="commitRightsData" class="button-sty">
				  <i class="el-icon-check el-icon"></i>
				  确 定
			  </el-button>
		  </span>
    </el-dialog>

    <!-- 单项权益 -->
    <designRightsDialog v-if="showDesignRightsDialog" @commit="commitSelectedRightsRow"
                        :visiable.sync="showDesignRightsDialog" multi="true" />
    <!-- 产品 -->
<!--    <preconditionDialog v-if="showItemDialog" @commitSelectedRow="commitSelectedRow2"-->
<!--                        :visiable.sync="showItemDialog" :multi="true" :brandId="formData.brandId"/>-->

<!--    <orderDialog v-if="showOrderDialog" :visiable.sync="showOrderDialog" :multi="true" @commit="confirmSite"/>-->
  </div>
</template>

<script>
import {selectDialogMixins} from '@/mixins/selectDialog/index.js';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue';
import store from "@/store";
import api from "@/api/projectApi";
import { mapGetters } from "vuex";

import {echoFileFormat, uploadFileFormat} from "@/util/uploadFormat";
import PhotoUpload from "@/components/formItem/photoUpload.vue";
import designRightsDialog from './designRightsDialog.vue';

export default {
  name: 'rightsDialog',
  props: ['visiable', 'multi', 'param', 'rightsObj'],
  mixins: [selectDialogMixins],
  components: {PhotoUpload, pager,designRightsDialog},

  created() {
    this.userRightsEdit = this.permissions["userRightsEdit"];
    this.initSetting()
    if (this.rightsObj) {
      this.formData = this.rightsObj
      // var type = this.formData.countTimesType;
      // if(type == 1){ //按时间
      //   this.isRightsTime = false;
      //   this.isRightsCount = true;
      //   this.isRightsMonths = true;
      // }else if(type == 2){ //按次数
      //   this.isRightsTime = true;
      //   this.isRightsCount = false;
      //   this.isRightsMonths = true;
      // }else if(type == 3){ //按累加月
      //   this.isRightsTime = true;
      //   this.isRightsCount = true;
      //   this.isRightsMonths = false;
      // }
      console.log(this.formData)
    }
  },

  watch: {
    // 'formData.brandId': {
    //   handler(newVal, oldVal) {
    //     this.brandOptions.forEach(item => {
    //       if (item.value === newVal) {
    //         this.formData.brandName = item.label
    //       }
    //     })
    //     // this.formData.brandId = newVal.value
    //     // this.formData.brandName = newVal.label
    //   },
    //   immediate: true,
    //   deep: true
    // },
    // picList1: {
    //   handler(newVal, oldVal) {
    //     this.formData.pic1 = uploadFileFormat(newVal)
    //   },
    //   immediate: true,
    //   deep: true
    // },
    // picList2: {
    //   handler(newVal, oldVal) {
    //     this.formData.pic2 = uploadFileFormat(newVal)
    //   },
    //   immediate: true,
    //   deep: true
    // },
    // picList3: {
    //   handler(newVal, oldVal) {
    //     this.formData.pic3 = uploadFileFormat(newVal)
    //   },
    //   immediate: true,
    //   deep: true
    // },
    // fileList: {
    //   handler(newVal, oldVal) {
    //     this.formData.eleRepariUrl = uploadFileFormat(newVal)
    //   },
    //   immediate: true,
    //   deep: true
    // }
  },

  mounted() {
    // this.loadBrandOption()
    // this.loadBuyChannelOption()
    //
    // this.loadProductOption0()
    // this.loadProductOption1()
  },

  computed: {
    ...mapGetters(["permissions"]),
    api() {
      return api
    },
    // pdfUrl() {
    //   if (this.formData.contractFile != null && this.formData.contractFile.length !== 0) {
    //     return this.formData.contractFile[0].url
    //   }
    //   return ''
    // },
    // itemCategory() {
    //   return this.formData.bigCategoryName + " " + this.formData.smallCategoryName
    // },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId ? tenantId : '1'
      };
    }
  },

  data() {
    return {
      showItemDialog: false,
      userRightsEdit: false,
      // getBrandListUrl: '/basic/snCompanyBrand/getBrandList',
      // getBuyChannelListUrl: '/basic/basBuyChannel/getList',
      // updateDataUrl: '/basic/basCustAsset/update',
      // addDataUrl: '/basic/basCustAsset/add',
      brandOptions: [],
      buyChannelOptions: [],
      productOptions0: [],
      productOptions1: [],
      upload_btn1: true,
      upload_btn2: true,
      upload_btn3: true,

      showPreconditionDialog2: false,
      showDesignRightsDialog: false,
      total: 0,
      filterText: '',
      data: [],
      notCreate: true,

      isRightsTime: false,
      isRightsCount: false,
      isRightsMonths: false,


      pageSizes: [10, 20, 100],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {
        profileId: '',
        id: null,
        barcode: '',
        rightsType: '',
        rightsCategory: '',
        rightsName: '',
        rightsNo: '',
        rightsStat: null,
        countTimesType: '',
        beginDate: '',
        endDate: '',
        unUesedTimes: null,
        uesedTimes: null,
        rightsMonthes: '',
        rightsRemark: '',
        unit: null,
        replaceFeeType: '',
        productNo: '',
        costPrice: '',
        salePrice: '',
        saleOrderNo: '',
        isReplaceFee: '',
        feeType: null,
        limitAmount: '',
        isLimit: null,
        // barcode2: '',
        // stat: 1,
        // brandId: null,
        // brandName: "",
        // itemId: '',
        // itemCode: "",
        // itemName: "",
        // bigCategoryId: '',
        // bigCategoryName: '',
        // smallCategoryId: '',
        // smallCategoryName: '',
        // extendPeriodMonth: 0,
        // standPeriodMonth: 0,
        // careDate: '',
        // fixDate: '',
        // instDate: '',
        // pic1: null,
        // pic2: null,
        // pic3: null,
        // eleRepariUrl: null,
        //
        // activeStat: 0,
        // repairCardNo: '',
        // contractFile: [],
      },
      showOrderDialog: false,
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      picList1: [],
      picList2: [],
      picList3: [],
      fileList: [],

    };
  },

  methods: {

    commitSelectedRightsRow(data) {
      console.log(data,"单项权益选择的值---->");
      this.formData.designId= data.id;
      this.formData.designCode = data.designCode;
      this.formData.rightsName = data.rightsName;
      this.formData.rightsCategory = data.rightsCategory;
      this.formData.rightsType = data.rightsType;
      if(data.unit==1){
        this.formData.unit = '月';
      }else{
        this.formData.unit = '次';
      }
      this.formData.effectType = data.effectType;
      this.formData.effectPeriod = data.effectPeriod;
      this.formData.feeType = data.feeType;
      this.formData.isLimit = data.isLimit;
      this.formData.settlePrice = data.settlePrice;
      this.formData.limitAmount = data.limitAmount;
      this.formData.isShow = data.isShow;
    },

    findRightsType(){
      var type = this.formData.countTimesType;
      if(type == 1){ //按时间
        this.isRightsTime = false;
        this.isRightsCount = true;
        this.isRightsMonths = true;
      }else if(type == 2){ //按次数
        this.isRightsTime = true;
        this.isRightsCount = false;
        this.isRightsMonths = true;
      }else if(type == 3){ //按累加月
        this.isRightsTime = true;
        this.isRightsCount = true;
        this.isRightsMonths = false;
      }
    },
    //     // 加载产品大类
    //     loadProductOption0() {
    //   fetchTree({
    //     categoryType: 1,  // 产品
    //     // usable: 1  // 加载启用的
    //   }).then(response => {
    //     this.productOptions0 = []
    //     response.data.data.forEach(item => {
    //       this.productOptions0.push({
    //         label: item.categoryName,
    //         value: item.id
    //       })
    //     })
    //   });
    // },

    // // 加载产品小类
    // loadProductOption1() {
    //   if (this.formData.bigCategoryId === ''
    //     || this.formData.bigCategoryId === null
    //     || this.formData.bigCategoryId === undefined) {
    //     this.productOptions1 = []
    //   } else {
    //     fetchTree({
    //       categoryType: 1,  // 产品
    //       // usable: 1,  // 加载启用的
    //       parentId: this.formData.bigCategoryId
    //     }).then(response => {
    //       this.productOptions1 = []
    //       response.data.data.forEach(item => {
    //         this.productOptions1.push({
    //           label: item.categoryName,
    //           value: item.id
    //         })
    //       })
    //     })
    //   }
    // },
    // 产品大类选中加载小类
    // productSelectOne() {
    //   this.productOptions1 = []
    //   this.formData.smallCategoryId = null
    //   this.loadProductOption1()
    // },
    // confirmSite(row) {
    //   console.log(row, '弹窗数据')
    //   this.formData.orderNo = row.orderNo
    //   if (row.id) {
    //     this.formData.orderId = row.id
    //   }
    //   if (row.orderId) {
    //     this.formData.orderId = row.orderId
    //   }
    // },

    // fileFormat() {
    //   this.picList1 = echoFileFormat(this.formData.pic1)
    //   this.picList2 = echoFileFormat(this.formData.pic2)
    //   this.picList3 = echoFileFormat(this.formData.pic3)
    //   this.fileList = echoFileFormat(this.formData.eleRepariUrl)
    // },

    // commitSelectedRow2(data) {
    //   this.formData.itemId = data.id
    //   this.formData.itemName = data.itemName
    //   this.formData.itemCode = data.itemCode
    //   this.formData.bigCategoryId = data.bigCategoryId
    //   this.formData.bigCategoryName = data.bigCategoryName
    //   this.formData.smallCategoryId = data.smallCategoryId
    //   this.formData.smallCategoryName = data.smallCategoryName
    //   this.loadProductOption1()
    //   console.log(this.formData)
    // },

    // showItemDialogFunc() {
    //   console.log(this.formData.brandId, 'brand')
    //   if (this.formData.brandId !== '' && this.formData.brandId !== null) {
    //     this.showItemDialog = true
    //   } else {
    //     this.$message.warning('请先选中品牌')
    //   }
    // },

    // 当前页面确认按钮逻辑
    commitRightsData() {
      if (this.formData.rightsName == null || this.formData.rightsName === '') {
        this.$message.error("权益名称不能为空！")
        return;
      }
      if (this.formData.rightsCategory == null || this.formData.rightsCategory === '') {
        this.$message.error("权益分类不能为空！")
        return;
      }
      if (this.formData.rightsType == null || this.formData.rightsType === '') {
          this.$message.error("权益类型不能为空！")
          return;
      }
      if (this.formData.rightsStat == null || this.formData.rightsStat === '') {
        this.$message.error("权益状态不能为空！")
        return;
      }
      if (this.formData.beginDate == null || this.formData.beginDate === '') {
        this.$message.error("权益开始时间不能为空！")
        return;
      }
      if (this.formData.endDate == null || this.formData.endDate === '') {
        this.$message.error("权益结束时间不能为空！")
        return;
      }
      if (this.formData.unUesedTimes == null || this.formData.unUesedTimes === '') {
        this.$message.error("权益可使用次数不能为空！")
        return;
      }
      // if (this.formData.replaceFeeType == null || this.formData.replaceFeeType === '') {
      //   this.$message.error("可抵扣费用不能为空！")
      //   return;
      // }
      this.$emit('commitRightsData', this.formData)
      this.dialogClose()
    },

    // pdfHandleSuccess(res, file, fileList) {
    //   // 上传成功后，隐藏上传按钮
    //   this.upload_btn = true;
    //   this.fileList = [
    //     {url: res.data.url}
    //   ]
    // },
    // pdfHandleRemove() {
    //   this.fileList = []
    // },
    // handleRemove1(response, file, fileList) {
    //   this.picList1 = []
    // },
    // handleRemove2(response, file, fileList) {
    //   this.picList2 = []
    // },
    // handleRemove3(response, file, fileList) {
    //   this.picList3 = []
    // },
    // handleSuccess1(res, file, fileList) {
    //   this.upload_btn1 = false;
    //   console.log(res.data.url, "url")
    //   this.picList1 = [
    //     {url: res.data.url}
    //   ]
    // },
    // handleSuccess2(res, file, fileList) {
    //   this.upload_btn2 = true;
    //   console.log(res.data.url, "url")
    //   this.picList2 = [
    //     {url: res.data.url}
    //   ]
    // },
    // handleSuccess3(res, file, fileList) {
    //   this.upload_btn3 = true;
    //   console.log(res.data.url, "url")
    //   this.picList3 = [
    //     {url: res.data.url}
    //   ]
    // },

    // 加载品牌
    // loadBrandOption() {
    //   this.$http({
    //     url: this.getBrandListUrl,
    //     method: 'post',
    //     data: {
    //       usable: 1  // 加载启用的
    //     }
    //   }).then(res => {
    //     this.brandOptions = []
    //     res.data.data.forEach(item => {
    //       this.brandOptions.push({
    //         label: item.brandName,
    //         value: item.id
    //       })
    //     })
    //   })
    // },
    // 加载购买渠道
    // loadBuyChannelOption() {
    //   this.$http({
    //     url: this.getBuyChannelListUrl,
    //     method: 'post',
    //     data: {
    //       buyChannelName: null
    //     }
    //   }).then(res => {
    //     this.buyChannelOptions = []
    //     res.data.data.forEach(item => {
    //       this.buyChannelOptions.push({
    //         label: item.buyChannelName,
    //         value: item.id
    //       })
    //     })
    //   })
    // },


  }
};
</script>
<style lang="scss" scoped>
.papers {
  position: absolute;
  left: 292px;
  top: 0px;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

// ::v-deep .el-dialog {
//     margin-top: 110px !important;
//     overflow: hidden;
// }


.d-item {
  border: 1px solid #ededed;
}

.table-detail {
  padding-left: 35px;
  display: inline-block;
}

.table-detail tr {
  margin-bottom: 10px;
  display: inline-block;

  th {
    font-weight: 400;
    text-align: right;
    width: 112px;
    font-size: 12px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);

  }

  // td{
  // 	display: inline-block;
  // 	width: 170px !important;
  // }
}

::v-deep tbody tr td .el-input {

  // width: 165px !important;
}

.title b {
  display: inline-block;
  line-height: 28px;
  font-size: 16px;
  font-weight: 600;
  margin-right: 84px;
  vertical-align: middle;
  color: #00c4b3;
  position: relative;
  z-index: 2;
  background: rgba(42, 100, 148, 0.16);
  margin-left: 0px;
  margin-top: 8px;
  padding-left: 12px;
  padding-right: 14px;
  border-radius: 0 28px 28px 0;
}

.detail-wrap {
  background-color: #fff;
  padding: 5px;
}

// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 570px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

.btn_zdy {
  margin: 10px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  // margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}
.vxe-grid .vxe-grid--pager-wrapper {
    display: block;
    width: 100%;
    position: fixed;
    bottom: -38px !important;
    position: absolute !important;
    z-index: 9999999;
    background-color: #ffffff;
}

</style>
